import { Routes } from '@angular/router';

export const adminRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./companies-table/companies-table.component').then((m) => m.CompaniesTableComponent),
  },
  {
    path: 'companies',
    loadComponent: () => import('./companies-table/companies-table.component').then((m) => m.CompaniesTableComponent),
  },
  {
    path: 'company-tier-setting',
    loadComponent: () =>
      import('@/admin/company-tier-setting-table/company-tier-setting-table.component').then(
        (m) => m.CompanyTierSettingTableComponent
      ),
  },
  {
    path: 'companies/:id/users',
    loadComponent: () =>
      import('./admin-users-table/admin-users-table.component').then((m) => m.AdminUsersTableComponent),
  },
  {
    path: 'companies/:id/stats',
    loadComponent: () => import('./company-stats/company-stats.component').then((m) => m.CompanyStatsComponent),
  },
  {
    path: 'shipping-carrier-credentials',
    loadComponent: () =>
      import('./shipping-carrier-credentials-table/shipping-carrier-credentials-table.component').then(
        (m) => m.ShippingCarrierCredentialsTableComponent
      ),
  },
  {
    path: 'carrier-invoice-imports',
    loadComponent: () =>
      import('./carrier-invoice-imports/carrier-invoice-imports.component').then(
        (m) => m.CarrierInvoiceImportsComponent
      ),
  },
  {
    path: 'carrier-invoice-reconciliation',
    loadComponent: () =>
      import('./carrier-invoice-reconciliation/carrier-invoice-reconciliation.component').then(
        (m) => m.CarrierInvoiceReconciliationComponent
      ),
  },
  {
    path: 'shipping-invoices',
    loadComponent: () =>
      import('./shipping-invoices/shipping-invoices.component').then((m) => m.ShippingInvoicesComponent),
  },
  {
    path: 'system-monitoring',
    loadComponent: () =>
      import('./system-monitoring/system-monitoring.component').then((m) => m.SystemMonitoringComponent),
  },
  {
    path: 'announcements',
    loadComponent: () => import('./announcements/announcements.component').then((m) => m.AnnouncementsComponent),
  },
];
